jQuery_T4NT(document).ready(function($) {

     /**
     *  Variant selection changed
     *  data-variant-toggle="{{variant.id}}"
     */
	   $( document ).on( "variant:changed", function( evt ) {
	     // console.log( evt.currentVariant );
	     // $('[data-variant-toggle]').hide(0);
	     // $('[data-variant-toggle="'+evt.currentVariant.id+'"]').show(0);
	   });



  $( "body .t4s-btn-filter" ).on( "click", function() {    
    //$( "body .brz-filter li" ).unbind();
    brz_click_bind();    
  });


 function brz_click_bind() {
   $( "body .t4s-drawer__content li" ).unbind();

     setTimeout(
    function() 
    {
  
      $( "body .t4s-drawer__content li" ).on( "click", function() {
         
        $('#f_overlay').show();
        $tag_url =  $(this).attr("data-href");

        //alert($tag_url);

        
        if ($(".t4s-drawer__content_2")[0]){
          if ($tag_url.indexOf("sort_by") >= 0){
             if ($tag_url.indexOf("filter-popup2") >= 0){
             }else{  
               //alert('okz2');
               //alert($tag_url);
               $tag_url = $tag_url+'&view=filter-popup2';               
             }
          }else{
            if ($tag_url.indexOf("filter-popup2") >= 0){
             }else{
              //alert('okz');
               //$tag_url = $tag_url+'?view=filter-popup2';              
              if ($tag_url.indexOf("?filter") >= 0){
                $tag_url = $tag_url+'&view=filter-popup2';
              }else{
                //$tag_url = $tag_url+'?view=filter-popup2';                
              }              
             }
          }
        }else{
          if ($tag_url.indexOf("sort_by") >= 0){
             if ($tag_url.indexOf("filter-popup") >= 0){
             }else{
               $tag_url = $tag_url+'&view=filter-popup';               
             }
          }else{
            if ($tag_url.indexOf("filter-popup") >= 0){
             }else{

              var url_parts = $tag_url.replace(/\/\s*$/,'').split('/'); 
              url_parts.shift(); 
              //console.log(url_parts);
              //alert(url_parts.length);

              if(url_parts.length>2){
                $tag_url = $tag_url+'&view=filter-popup'; 
              }




              
                            
             }
          }
        }

        //alert($tag_url);

        

    
        $.ajax({
    		url:	$tag_url,
    		type:	'GET'
    	})
    	.done(function(data) {          
          $('.t4s-drawer__left .t4s-drawer__content').html($(data).find('.t4s-drawer__content').html());
          $coll_filter_url =  $(data).find('.coll_filter_btn').attr('href')
          $h_url = $tag_url.split("&view");         
          
          $('.t4s-active-filters3 a').attr("href", $h_url[0]);
          $('.t4s-active-filters3 a').click();
          
           setTimeout(
          function() 
          {
           brz_click_bind();
           $('#f_overlay').hide(); 
          }, 1000);
          
      
          
    	})
    	.fail(function(data) {})
    	.always(function(data) {});
          
          
        });
      
    }, 800);

  
 }



// cart page copy btn function----------
     $( ".btn_cart_btn_text" ).on( "click", function() {
     /*set_addi_field_val('vornameInput');
     set_addi_field_val('nachnameInput');
     set_addi_field_val('emailInput');
     set_addi_field_val('funktionInput');
     */
     if ($("#btn_cart_btn_text").hasClass("clk_btn_cart_btn")) {  
     }else{
       $("#btn_cart_btn_text").addClass("clk_btn_cart_btn");
     }
     
     var numItems = $('.FieldSetWrapper_cartpage').length;
     if(numItems>1){
       numItems = numItems+parseInt(1);
       for(var i = 1; i < numItems; i++){
        // vornameInput
         var numInp = $('#participantFieldSetWrapper_'+i+' .vornameInput').length+parseInt(1);
         for(var k = 1; k < numInp; k++){
           var Inp_vornameInput = $('#participantFieldSetWrapper_'+i+' .vornameInput'+k).val();
           if(Inp_vornameInput!=''){             
             $('.vornameInput'+k).val(Inp_vornameInput);
           }
           //
           var Inp_nachnameInput= $('#participantFieldSetWrapper_'+i+' .nachnameInput'+k).val();
           if(Inp_nachnameInput!=''){             
             $('.nachnameInput'+k).val(Inp_nachnameInput);
           }
           //
           var Inp_emailInput = $('#participantFieldSetWrapper_'+i+' .emailInput'+k).val();
           if(Inp_emailInput!=''){             
             $('.emailInput'+k).val(Inp_emailInput);
           }
           //
           var Inp_funktionInput = $('#participantFieldSetWrapper_'+i+' .funktionInput'+k).val();
           if(Inp_funktionInput!=''){             
             $('.funktionInput'+k).val(Inp_funktionInput);
           }
         }
       }       
     }

     setTimeout(
  function() 
  {
    $("#btn_cart_btn_text").removeClass("clk_btn_cart_btn");
  }, 3000);
     //alert(numItems);    
    //brz_click_bind();
  });


  //Product page

  $( ".brz_map_link_url" ).on( "click", function() {
    var brz_loc= $(this).parent().find(".brz_map_link").html();

    if(brz_loc !=''){
      var m_url = "https://www.google.com/maps/place/"+brz_loc.trim();      
      //window.open(m_url, null, "height=500,width=800,status=yes,toolbar=no,menubar=no,location=no");
      PopupCenter(m_url, 'Veranstaltungsort', 1000, 700);
      
    }
    
  });



  function PopupCenter(url, title, w, h) {
      // Fixes dual-screen position                         Most browsers      Firefox
      var dualScreenLeft = window.screenLeft != undefined ? window.screenLeft : screen.left;
      var dualScreenTop = window.screenTop != undefined ? window.screenTop : screen.top;

      width = window.innerWidth ? window.innerWidth : document.documentElement.clientWidth ? document.documentElement.clientWidth : screen.width;
      height = window.innerHeight ? window.innerHeight : document.documentElement.clientHeight ? document.documentElement.clientHeight : screen.height;

      var left = ((width / 2) - (w / 2)) + dualScreenLeft;
      var top = ((height / 2) - (h / 2)) + dualScreenTop;
      var newWindow = window.open(url, title, 'scrollbars=yes, width=' + w + ', height=' + h + ', top=' + top + ', left=' + left);

      // Puts focus on the newWindow
      if (window.focus) {
          newWindow.focus();
      }
  }



  //---------End------------

    

});